import {
  useV2GetProductAccountingQuery,
  V2ProductAccountingResource,
  V2ServiceCategoryResource,
} from "@generated";
import {
  ProductAccountingCode,
  ProductWithCode,
  ServiceCategory,
} from "../types";

const useGetProductAccountingCodes = (productId, id) => {
  let customError: string | null = null;
  const { data, error, isLoading, refetch, isFetching } =
    useV2GetProductAccountingQuery({
      productId,
      id,
      include: ["service-category"],
    });

  let acctCodeData: ProductWithCode | undefined = undefined;

  if (data?.data) {
    try {
      const prodAcctId = data.data.id ? Number(data.data.id) : 0;
      const prodAcctCode = data.data?.attributes?.code || "";

      let acctCode: ProductAccountingCode[] = [];
      let category: ServiceCategory[] = [];

      if (prodAcctCode) {
        acctCode.push({
          id: prodAcctId,
          type: "product-accountings",
          attributes: { code: prodAcctCode },
          relationships: {
            product: null,
            serviceCategory: null,
          },
        } as ProductAccountingCode);
      }

      const serviceCategoryId =
        data.data?.relationships?.["service-category"]?.data?.id;
      if (serviceCategoryId) {
        const serviceCategory = data.included?.find(
          (item) =>
            item.type === "service-categories" && item.id === serviceCategoryId
        );
        if (serviceCategory && serviceCategory.type === "service-categories") {
          const serviceCategoryResource =
            serviceCategory as V2ServiceCategoryResource;
          category.push({
            id: Number(serviceCategoryResource.id),
            type: "service-categories",
            attributes: {
              nestedName:
                serviceCategoryResource.attributes?.["nested-name"] || "",
            },
          });
        }
      }

      acctCodeData = {
        id: prodAcctId,
        type: "product-accountings",
        acctCode: [
          {
            id: prodAcctId,
            type: "product-accountings",
            attributes: { code: prodAcctCode },
            relationships: {
              serviceCategory: null,
              product: null,
            },
          },
        ],
        category,
        serviceCategoryId: serviceCategoryId
          ? Number(serviceCategoryId)
          : undefined,
      };
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    acctCodeData,
    isLoading,
    error: error ?? customError,
    refetch,
    isFetching,
  };
};
export default useGetProductAccountingCodes;
